"use client";

//https://nextjs.org/docs/app/building-your-application/routing/linking-and-navigating#windowhistorypushstate
import { useState, useEffect } from "react";

type useSearchParamsReturn = [URLSearchParams, (searchParam: URLSearchParams) => void];

export default function useSearchParams(query?: string): useSearchParamsReturn {
  const [params, setParams] = useState<URLSearchParams>(new URLSearchParams(query));

  /**
   *
   * @param searchParams the params you want to set
   */
  function set(searchParams: URLSearchParams, blockBack?: boolean) {
    if (blockBack) {
      window.history.replaceState(null, "", `?${searchParams.toString()}`);
    } else {
      window.history.pushState(null, "", `?${searchParams.toString()}`);
    }
  }

  /**
   * set search params when loaded in browser
   */
  useEffect(() => {
    setParams(new URLSearchParams(window.location.search));
  }, []);

  /**
   * listen to url changes and update params
   */
  useEffect(() => {
    //@ts-ignore
    window.navigation.addEventListener("navigate", (event) => {
      const search = (event.destination.url ?? "").split("?")?.[1];
      setParams(new URLSearchParams(search));
    });
  }, []);

  return [params, set];
}
